// Push notification related types

export interface NotificationPayload {
  notification?: {
    title?: string;
    body?: string;
    image?: string;
  };
  data?: {
    [key: string]: string;
  };
  fcmOptions?: {
    link?: string;
  };
}

export interface FCMToken {
  token: string;
  timestamp: number;
}

export interface NotificationPermissionState {
  permission: NotificationPermission;
  isSupported: boolean;
  isEnabled: boolean;
}

export interface PushNotificationService {
  requestPermission: () => Promise<NotificationPermission>;
  getToken: () => Promise<string | null>;
  deleteToken: () => Promise<void>;
  subscribeToTopic: (topic: string) => Promise<void>;
  unsubscribeFromTopic: (topic: string) => Promise<void>;
  onMessage: (callback: (payload: NotificationPayload) => void) => void;
  getPermissionState: () => NotificationPermissionState;
}

export interface NotificationSubscription {
  token: string;
  topics: string[];
  userId?: string;
  deviceId?: string;
  userAgent?: string;
  createdAt: Date;
  lastUpdated: Date;
}

export enum NotificationTopics {
  GENERAL = 'general',
  ALERTS = 'alerts',
  UPDATES = 'updates',
  CHAT = 'chat',
  SYSTEM = 'system'
}

export interface NotificationSettings {
  enabled: boolean;
  topics: {
    [key in NotificationTopics]: boolean;
  };
  quietHours?: {
    enabled: boolean;
    start: string; // HH:MM format
    end: string; // HH:MM format
  };
  sound: boolean;
  vibrate: boolean;
}